import IPropertyType from "../propertyType/PropertyTypeData";
import IPropertyCalculatedData from "./PropertyCalculatedData";
import { IFormulaDetails } from "./PropertyViewData";

export interface IPropertyAttributeData {
    id: string;
    name: string;
    variable: string;
    atribute: string;
}

export default interface IPropertyFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    customId: string;
    name: string;
    type: string;
    typeId: string;
    unit: string;
    decimals: string;
    description: string;
    formula: string;
    propertyTypes: any[];
    formulaVariables: IPropertyCalculatedData[];
    formulaDetails: IFormulaDetails;

}

export class PropertyFormData implements IPropertyFormData {
    isEditMode: boolean;
    requestId: string;
    id: string;
    customId: string;
    name: string;
    type: string;
    typeId: string;
    unit: string;
    decimals: string;
    description: string;
    formula: string;
    propertyTypes: any[];
    formulaVariables: IPropertyCalculatedData[];
    formulaDetails: IFormulaDetails;

    constructor(isEditMode: boolean, requestId: string, id: string, customId: string, name: string, type: string, typeId: string, unit: string, decimals: string, 
        descriptions: string, formula: string, propertyTypes: IPropertyType[], 
        formulaVariables: IPropertyCalculatedData[], formulaDetails: IFormulaDetails) {

        this.isEditMode = isEditMode;
        this.requestId = requestId;
        this.id = id;
        this.customId = customId;
        this.name = name;
        this.type = type;
        this.typeId = typeId;
        this.unit = unit;
        this.decimals = decimals;
        this.description = descriptions;
        this.formula = formula;
        this.formulaVariables = formulaVariables;
        this.formulaDetails = formulaDetails;

        this.propertyTypes = [{
            label: this.type,
            value: this.typeId
        }];

    }

}